module.exports = __webpack_public_path__ + "static/media/covid_qr_p2_1.2d42251c.png";